import React from "react"

const PreiseTermine = (props) => {
  if (props.preiseUndTermine === null) {
    return (
      <div className="text-center">
        Preise und Termine auf{" "}
        <a
          className="underline"
          href={`mailto:info@baerkopf.at?subject=${props.destination}`}
        >
          Anfrage
        </a>
      </div>
    )
  } else
    return props.preiseUndTermine.map((preisTermin, index) => {
      if (preisTermin.einzelzimmerPreis === null) {
        return (
          <tbody key={index}>
            <tr>
              <td>
                <span title={preisTermin.fullTermin}>{preisTermin.termin}</span>{" "}
                - <span title={preisTermin.fullEnde}>{preisTermin.ende}</span>
              </td>
              <td>{preisTermin.beschreibung}</td>
              <td>{preisTermin.preis} €</td>
            </tr>
          </tbody>
        )
      } else {
        return (
          <tbody key={index}>
            <tr>
              <td>
                <span title={preisTermin.fullTermin}>{preisTermin.termin}</span>{" "}
                - <span title={preisTermin.fullEnde}>{preisTermin.ende}</span>
              </td>
              <td>{preisTermin.beschreibung}</td>
              <td>{preisTermin.preis} €</td>
            </tr>
            <tr>
              <td colSpan="2">Einzelzimmer</td>
              <td style={{ whiteSpace: `nowrap` }}>
                {preisTermin.einzelzimmerPreis} €
              </td>
            </tr>
          </tbody>
        )
      }
    })
}
export default PreiseTermine
